import { apiCommon } from 'src/api/ApiCommon';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { CmsDisplayOrderDataModelType } from 'src/api/config/cmsDisplayOrder/getAllDisplayOrders';

export class CmsDisplayOrderState {
    public readonly displayOrderResource: Resource<Array<CmsDisplayOrderDataModelType>>;

    constructor() {
        this.displayOrderResource = new Resource(async (): Promise<Array<CmsDisplayOrderDataModelType>> => {
            return await apiCommon.getAllCmsDisplayOrders.run({});
        });
    }
}
